import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-graphite-850 border-t border-graphite-700/50">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-16 py-14">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-8">
          <div className="col-span-2 lg:col-span-1">
            <div className="flex items-center gap-3">
              <img
                alt="StackMap Systems"
                className="h-[84px] md:h-[116px] w-auto object-contain"
                src="https://public.readdy.ai/ai/img_res/bb18d063-181d-43b7-ad64-6d8566caa367.png"
              />
            </div>
            <p className="text-sm text-silver-400 leading-relaxed mb-4">
              Operational Infrastructure for Scale. We help businesses move from fragmented tools to structured, intelligent operations.
            </p>
            <div className="flex items-center gap-3">
              <a href="#" rel="nofollow" className="w-8 h-8 flex items-center justify-center rounded-md bg-graphite-700 hover:bg-graphite-600 text-silver-300 hover:text-white transition-colors" aria-label="LinkedIn">
                <i className="ri-linkedin-fill text-sm" />
              </a>
              <a href="#" rel="nofollow" className="w-8 h-8 flex items-center justify-center rounded-md bg-graphite-700 hover:bg-graphite-600 text-silver-300 hover:text-white transition-colors" aria-label="Twitter">
                <i className="ri-twitter-x-fill text-sm" />
              </a>
              <a href="#" rel="nofollow" className="w-8 h-8 flex items-center justify-center rounded-md bg-graphite-700 hover:bg-graphite-600 text-silver-300 hover:text-white transition-colors" aria-label="Facebook">
                <i className="ri-facebook-fill text-sm" />
              </a>
              <a href="#" rel="nofollow" className="w-8 h-8 flex items-center justify-center rounded-md bg-graphite-700 hover:bg-graphite-600 text-silver-300 hover:text-white transition-colors" aria-label="Instagram">
                <i className="ri-instagram-line text-sm" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 tracking-wide uppercase">Products</h4>
            <ul className="space-y-2.5">
              <li><Link to="/products" className="text-sm text-silver-400 hover:text-silver-200 transition-colors">StackMap BOS</Link></li>
              <li><Link to="/products/oms" className="text-sm text-silver-400 hover:text-silver-200 transition-colors">OMS</Link></li>
              <li><Link to="/products/get-fit" className="text-sm text-silver-400 hover:text-silver-200 transition-colors">Get Fit</Link></li>
              <li><Link to="/bespoke" className="text-sm text-silver-400 hover:text-silver-200 transition-colors">Bespoke Development</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 tracking-wide uppercase">Company</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-silver-400 hover:text-silver-200 transition-colors">About</Link></li>
              <li><Link to="/solutions" className="text-sm text-silver-400 hover:text-silver-200 transition-colors">Solutions</Link></li>
              <li><Link to="/pricing" className="text-sm text-silver-400 hover:text-silver-200 transition-colors">Pricing</Link></li>
              <li><Link to="/contact" className="text-sm text-silver-400 hover:text-silver-200 transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 tracking-wide uppercase">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2.5">
                <i className="ri-mail-line text-emerald-accent mt-0.5 text-sm" />
                <span className="text-sm text-silver-400">info@stackmapsystems.com</span>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-phone-line text-emerald-accent mt-0.5 text-sm" />
                <span className="text-sm text-silver-400">+234 8163 000 0009</span>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-phone-line text-emerald-accent mt-0.5 text-sm" />
                <span className="text-sm text-silver-400">+1 437 424 8823</span>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-map-pin-line text-emerald-accent mt-0.5 text-sm" />
                <span className="text-sm text-silver-400">15 Kudirat Abiola Way, Oregun, Lagos</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-graphite-700/50 px-4 sm:px-6 lg:px-8 xl:px-16 py-5">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-silver-400">&copy; 2026 StackMap Systems. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-xs text-silver-400 hover:text-silver-200 transition-colors">Privacy Policy</a>
            <a href="#" className="text-xs text-silver-400 hover:text-silver-200 transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}